import { IMultipleIdsParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class RunCreateExtractsOnWorkbooksRequest extends Request<IMultipleIdsParams, IResult> {
  constructor(ids: string[]) {
    super('runCreateExtractsOnWorkbooks', {
      ids: ids
    });
  }
}
